<!--
 * @Author: 'lek' '2889356275@qq.com'
 * @Date: 2025-03-10
 * @Description: 404 错误页面
 -->
<template>
  <div class="error-page">
    <div class="error-container">
      <!-- 装饰性背景元素 -->
      <div class="bg-decoration">
        <div class="floating-molecule molecule-1"></div>
        <div class="floating-molecule molecule-2"></div>
        <div class="floating-molecule molecule-3"></div>
        <div class="floating-molecule molecule-4"></div>
        <div class="floating-molecule molecule-5"></div>
      </div>

      <!-- 主内容区 -->
      <div class="error-content">
        <!-- 404 数字动画 -->
        <div class="error-code">
          <span class="digit digit-4">4</span>
          <div class="dish-container">
            <div class="petri-dish">
              <div class="dish-inner"></div>
              <div class="dish-glow"></div>
            </div>
          </div>
          <span class="digit digit-4-last">4</span>
        </div>

        <!-- 错误信息 -->
        <div class="error-message">
          <h1 class="error-title">{{ $t('error.title') }}</h1>
          <p class="error-description">{{ $t('error.description') }}</p>
        </div>

        <!-- 操作按钮 -->
        <div class="error-actions">
          <button class="btn-primary" @click="goHome">
            <span class="btn-icon">←</span>
            <span>{{ $t('error.backHome') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  methods: {
    goHome() {
      this.$router.push('/welcome');
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 50%, #f8f9fa 100%);
  position: relative;
  overflow: hidden;
  font-family: 'Microsoft YaHei', 'PingFang SC', sans-serif;
}

.error-container {
  position: relative;
  z-index: 10;
  text-align: center;
  padding: 40px 20px;
}

/* 背景装饰元素 */
.bg-decoration {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.floating-molecule {
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 212, 180, 0.4) 0%, rgba(0, 184, 148, 0.2) 50%, transparent 80%);
  animation: floatMolecule 8s ease-in-out infinite;
}

.molecule-1 {
  width: 80px;
  height: 80px;
  top: 10%;
  left: 5%;
  animation-delay: 0s;
}

.molecule-2 {
  width: 60px;
  height: 60px;
  top: 20%;
  right: 10%;
  animation-delay: 1.5s;
}

.molecule-3 {
  width: 100px;
  height: 100px;
  bottom: 15%;
  left: 8%;
  animation-delay: 3s;
}

.molecule-4 {
  width: 50px;
  height: 50px;
  bottom: 25%;
  right: 5%;
  animation-delay: 2s;
}

.molecule-5 {
  width: 70px;
  height: 70px;
  top: 50%;
  right: 15%;
  animation-delay: 4s;
}

@keyframes floatMolecule {
  0%, 100% {
    transform: translateY(0) scale(1);
    opacity: 0.3;
  }
  50% {
    transform: translateY(-30px) scale(1.1);
    opacity: 0.6;
  }
}

/* 主内容区 */
.error-content {
  position: relative;
  z-index: 10;
}

/* 404 数字样式 */
.error-code {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
}

.digit {
  font-size: clamp(80px, 15vw, 150px);
  font-weight: 800;
  background: linear-gradient(135deg, #34495e 0%, #00D4B4 50%, #1a252f 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1;
  animation: digitPulse 3s ease-in-out infinite;
}

.digit-4 {
  animation-delay: 0s;
}

.digit-4-last {
  animation-delay: 0.5s;
}

@keyframes digitPulse {
  0%, 100% {
    transform: scale(1);
    filter: brightness(1);
  }
  50% {
    transform: scale(1.02);
    filter: brightness(1.1);
  }
}

/* 中间的培养皿替代0 */
.dish-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.petri-dish {
  width: clamp(80px, 15vw, 150px);
  height: clamp(80px, 15vw, 150px);
  border-radius: 50%;
  background:
    radial-gradient(circle at 30% 30%, rgba(255, 255, 255, 0.4), transparent 50%),
    linear-gradient(145deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.1));
  backdrop-filter: blur(10px);
  border: 6px solid rgba(0, 212, 180, 0.3);
  box-shadow:
    0 8px 32px rgba(0, 212, 180, 0.2),
    inset 0 2px 0 rgba(255, 255, 255, 0.4);
  position: relative;
  animation: dishRotate 20s linear infinite;
}

.dish-inner {
  position: absolute;
  top: 15%;
  left: 15%;
  right: 15%;
  bottom: 15%;
  border-radius: 50%;
  background: radial-gradient(circle, transparent 30%, rgba(0, 212, 180, 0.1) 100%);
  border: 2px solid rgba(0, 212, 180, 0.15);
}

.dish-glow {
  position: absolute;
  top: -10%;
  left: -10%;
  right: -10%;
  bottom: -10%;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(0, 212, 180, 0.15) 0%, transparent 70%);
  animation: dishGlow 4s ease-in-out infinite;
}

@keyframes dishRotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes dishGlow {
  0%, 100% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

/* 错误信息样式 */
.error-message {
  margin-bottom: 50px;
}

.error-title {
  font-size: clamp(24px, 4vw, 36px);
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
  letter-spacing: 0.05em;
}

.error-description {
  font-size: clamp(14px, 2vw, 18px);
  color: #7f8c8d;
  max-width: 500px;
  margin: 0 auto;
  line-height: 1.8;
}

/* 按钮样式 */
.error-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  background: linear-gradient(135deg, #00D4B4 0%, #00B894 100%);
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0, 212, 180, 0.3);
  position: relative;
  overflow: hidden;
}

.btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0, 212, 180, 0.4);
}

.btn-primary:hover::before {
  left: 100%;
}

.btn-primary:active {
  transform: translateY(-1px);
}

.btn-icon {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.btn-primary:hover .btn-icon {
  transform: translateX(-3px);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .error-container {
    padding: 30px 15px;
  }

  .error-code {
    gap: 10px;
    margin-bottom: 30px;
  }

  .petri-dish {
    border-width: 4px;
  }

  .error-message {
    margin-bottom: 40px;
  }

  .btn-primary {
    padding: 12px 28px;
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .error-code {
    gap: 5px;
  }

  .error-message {
    margin-bottom: 30px;
  }

  .error-description {
    padding: 0 10px;
  }

  .btn-primary {
    padding: 10px 24px;
    font-size: 14px;
  }

  .floating-molecule {
    opacity: 0.3;
  }
}
</style>